import type { OkBody } from '../Models/ApiModel';
import type { LessonDraftModel, LessonModel } from '../Models/LessonModel';
import type { LessonStatus } from '../Models/enums';
import { http } from './httpService';

/** The fields a lesson can be edited on after it exists. */
export type LessonPatch = Partial<Pick<LessonModel, 'student' | 'date' | 'time' | 'amount' | 'status'>>;

export const LessonService = {
  list: () => http.get<LessonModel[]>('/lessons'),

  /**
   * A lesson with no time inherits the student's recurring slot for that
   * weekday, so it lands at the right hour in the calendar and its debt clock
   * starts when the lesson ends rather than at midnight. Send `time: null`
   * explicitly to opt out.
   */
  create: (lesson: LessonDraftModel) => http.post<LessonModel>('/lessons', lesson),

  update: (id: number, patch: LessonPatch) => http.patch<LessonModel>(`/lessons/${id}`, patch),

  setStatus: (id: number, status: LessonStatus) =>
    http.patch<LessonModel>(`/lessons/${id}`, { status }),

  /** Moves the lesson and sets it back to unpaid, which is what a move means. */
  postpone: (id: number, date: string, time: string | null) =>
    http.post<LessonModel>(`/lessons/${id}/postpone`, { date, time }),

  remove: (id: number) => http.delete<OkBody>(`/lessons/${id}`),

  removeAll: () => http.delete<OkBody>('/lessons'),

  linkCalendarEvent: (id: number, gcalEventId: string | null) =>
    http.patch<{ id: number; gcalEventId: string | null }>(`/lessons/${id}/gcal-link`, { gcalEventId })
};
